<template>
    <svg id="Ordenação_de_listagem" data-name="Ordenação de listagem" xmlns="http://www.w3.org/2000/svg" width="10" height="8.333" viewBox="0 0 10 8.333">
        <path id="Polígono_4" data-name="Polígono 4" d="M5,0l5,8.333H0Z" transform="translate(10 8.333) rotate(180)"/>
    </svg>
</template>
